export default () => (
  <svg
    width='22px'
    height='22px'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 100 100'
    preserveAspectRatio='xMidYMid'
    class='uil-ring-alt'>
    <rect x='0' y='0' width='100' height='100' fill='none' class='bk' />
    <circle cx='50' cy='50' r='40' stroke='none' fill='none' stroke-width='10' stroke-linecap='round' />
    <circle cx='50' cy='50' r='40' stroke='#fff' fill='none' stroke-width='6' stroke-linecap='round'>
      <animate attributeName='stroke-dashoffset' dur='1.75s' repeatCount='indefinite' from='0' to='502' />
      <animate
        attributeName='stroke-dasharray'
        dur='1.75s'
        repeatCount='indefinite'
        values='175.7 75.30000000000001;1 250;175.7 75.30000000000001'
      />
    </circle>
  </svg>
)
